<div class="calendar-viewer">

  <div role="row" class="calendar-viewer__head">
    <i (click)="next()" class="calendar-viewer__button fa fa-chevron-right"></i>
    <i (click)="toDay()" class="calendar-viewer__button fa fa-circle" style="font-size:10px"></i>
    <i (click)="prev()" class="calendar-viewer__button fa fa-chevron-left"></i>
    <div class="calendar-viewer__title">{{dateTitle}}</div>
  </div>

  <div role="grid" class="calendar-viewer__body">
    <div role="row" class="calendar-viewer__row">
      <div class="calendar-viewer__th" *ngFor="let title of weekTitles">{{title}}</div>
    </div>
    <div *ngFor="let week of weekDates" role="row" class="calendar-viewer__row">
      <div *ngFor="let dateViewer of week"
           [ngClass]="{'light-cell': dateViewer.outOfRange, 'today-cell': dateViewer.today}" class="calendar-viewer__td">
        <div (click)="activeDate(dateViewer)" class="calendar-viewer__date" [ngClass]="{'active': dateViewer.time === dateActive?.time}">
          <span>{{dateViewer.date.getDate()}}</span>
          <div *ngIf="dateViewer.events" class="calendar-viewer__events">
            <div *ngFor="let event of dateViewer.events" [ngStyle]="event.style"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
